export const animation = {
  maskShowDuration: 0.5,
  maskHoldDuration: 0.25,
  maskHideDuration: 0.75,
  lineDuration: 0.15,
  wordDuration: 0.15,
  expeditionMaskDuration: 1.2,
}
